import { useState } from 'react';
import { flushSync } from 'react-dom';

import { ProductMatchingTargetParameters } from './interfaces/ProductMatchingSummary';
import { useEquivalentProductMatching } from './useEquivalentProductMatching';

type ReplaceIfNoAlertsFunction = (args: {
    targetParameters: ProductMatchingTargetParameters;
    onAlertsCallback?: () => unknown;
    onNoAlertsCallback?: () => unknown;
}) => Promise<unknown>;

const ConditionalLoader: React.FC<{ show: boolean }> = (_args) => {
    return null;
    // return _args.show ? <PageLoader /> : null;
};

export const useLazyEquivalentProductMatchingSummaryAlerts = (): {
    LoaderOnAlerts: React.FC<{ forceShow?: boolean }>;
    replaceIfNoAlerts: ReplaceIfNoAlertsFunction;
} => {
    const { getAlerts, replaceProductsWithEquivalents } = useEquivalentProductMatching();
    const [showLoader, setShowLoader] = useState(false);

    /**
     * gets alerts using the equivalent matching criteria. Then triggers replacement if no alerts
     */
    const replaceIfNoAlerts: ReplaceIfNoAlertsFunction = async ({
        targetParameters,
        onAlertsCallback,
        onNoAlertsCallback,
    }) => {
        flushSync(() => {
            setShowLoader(true);
        });

        const alerts = await getAlerts(targetParameters);
        if (alerts.length > 0) {
            onAlertsCallback?.();
        } else {
            await replaceProductsWithEquivalents(targetParameters);
            onNoAlertsCallback?.();
        }
        setShowLoader(false);
    };

    const LoaderOnAlerts: React.FC<{ forceShow?: boolean }> = (args) => {
        return <ConditionalLoader show={!!showLoader || !!args.forceShow} />;
    };

    return { LoaderOnAlerts, replaceIfNoAlerts };
};
